module.exports = __webpack_public_path__ + "img/type_DARK.017593fb.png";